// Lib
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Utils
import { prop } from '../../../../common/utils/immutableHelper';
import { getCurrentUser } from '../../../user/currentUserSelector';
import { getIsGuestProp } from '../../../../common/users/utils/userPropertyUtils';

// Actions
import { navigateToLogin } from '../../../reducers/navigationActions';

// Components
import ModalActionsList from '../../modal/ModalActionsList';

type Props = {
    error: object;
    close: () => void;
    errorNoticeData: object;
};

const BoardSimpleErrorContent: React.FC<Props> = ({ error, close, errorNoticeData }) => {
    const currentUser = useSelector(getCurrentUser);

    const dispatch = useDispatch();

    // If the board is being restored (e.g. the user navigated directly to "app.milanote.com" without specifying
    // the board ID, then we are loading their last viewed board ID) then don't show an error, just return them to
    // their home board
    React.useEffect(() => {
        const isRestored = prop('isRestored', errorNoticeData);
        if (isRestored) close();
    }, []);

    const isGuest = getIsGuestProp(currentUser);

    const guestActions = [
        {
            text: 'Log in',
            func: (event: Event) => {
                event.preventDefault();
                dispatch(navigateToLogin());
            },
        },
    ];
    const actions = isGuest ? guestActions : [];

    return (
        <>
            <h2>{prop('message', error)}</h2>
            <div>
                <p>Sorry, the board you&apos;re trying to access no longer exists.</p>
                <ModalActionsList actions={actions} />
            </div>
        </>
    );
};

export default BoardSimpleErrorContent;
